import React from "react";
import { ArrowUpRight } from "lucide-react";

/**
 * Reusable CTA button. External links open in new tab.
 * variant: "primary" | "secondary"
 */
export default function CTAButton({
    href,
    to,
    variant = "primary",
    children,
    testId,
    icon = true,
    external = false,
    className = "",
    onClick,
}) {
    const cls = variant === "primary" ? "btn-primary" : "btn-secondary";

    const content = (
        <>
            <span>{children}</span>
            {icon && (
                <ArrowUpRight
                    size={16}
                    strokeWidth={2}
                    aria-hidden="true"
                    className="opacity-90"
                />
            )}
        </>
    );

    if (href) {
        return (
            <a
                href={href}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
                className={`${cls} ${className}`}
                data-testid={testId}
                onClick={onClick}
            >
                {content}
            </a>
        );
    }
    return (
        <button
            type="button"
            className={`${cls} ${className}`}
            data-testid={testId}
            onClick={onClick}
        >
            {content}
        </button>
    );
}
